import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function contactsReducer(state = initialState.workQueues , action) {
    if (action.type === types.LOAD_WORKQUEUE_SUCCESS)
    {
        return action.workQueues
    }
    else {
        return state;
    }
}
